import { IPayByLinkData, PaymentType, PaymentTypeTagging } from '@ace-clublabs/payment-types';
import { Environments, getEnvironmentFromHost } from '../api/endpoints';

export const identityLoginUrl = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  let identityLoginUrl = '';

  switch (env) {
    case Environments.local:
    case Environments.localProxy:
    case Environments.dev1:
      identityLoginUrl = 'https://appdev1.ace.aaa.com/enterprise/identity/dev/#/login';
      break;
    case Environments.qa1:
      identityLoginUrl = 'https://appqa1.ace.aaa.com/enterprise/identity/qa/#/login';
      break;
    case Environments.uat1:
      identityLoginUrl = 'https://appuat1.ace.aaa.com/enterprise/identity/uat/#/login';
      break;
    case Environments.prod:
      identityLoginUrl = 'https://app.ace.aaa.com/enterprise/identity/#/login';
      break;
  }
  return identityLoginUrl;
};

export const getIdentityEnv = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  let identityEnv = '';

  switch (env) {
    case Environments.local:
    case Environments.dev1:
    case Environments.qa1:
    case Environments.uat1:
      identityEnv = 'non-prod';
      break;
    case Environments.prod:
      identityEnv = 'prod';
      break;
  }
  return identityEnv;
};

export const getIdentityRedirectUri = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  let identityRedirectUri = '';

  switch (env) {
    case Environments.local:
      identityRedirectUri = `https://localhost:8080/payments/auth`;
      break;
    case Environments.localProxy:
      identityRedirectUri = `https://payments.app.ace.aaa.com:8080/payments/auth`;
      break;
    case Environments.dev1:
      identityRedirectUri = `https://appdev1.ace.aaa.com/payments/auth`;
      break;
    case Environments.qa1:
      identityRedirectUri = `https://appqa1.ace.aaa.com/payments/auth`;
      break;
    case Environments.uat1:
      identityRedirectUri = `https://appuat1.ace.aaa.com/payments/auth`;
      break;
    case Environments.prod:
      identityRedirectUri = `https://app.ace.aaa.com/payments/auth`;
      break;
  }

  return identityRedirectUri;
};

export const getTermsUrl = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  let termsUrl = '';

  switch (env) {
    case Environments.local:
    case Environments.localProxy:
    case Environments.dev1:
    case Environments.dev2:
      termsUrl = 'https://appdev1.ace.aaa.com/payments/termsandconditions';
      break;
    case Environments.qa1:
    case Environments.qa2:
      termsUrl = 'https://appqa1.ace.aaa.com/payments/termsandconditions';
      break;
    case Environments.uat1:
    case Environments.uat2:
      termsUrl = 'https://appuat1.ace.aaa.com/payments/termsandconditions';
      break;
    case Environments.prod:
      termsUrl = 'https://app.ace.aaa.com/payments/termsandconditions';
      break;
  }
  return termsUrl;
};

export const getPaymentPBLTaggingFlow = (payByLinkData: IPayByLinkData | undefined) => {
  const products = payByLinkData?.products || [];
  const productTypes = products.map((product: any) => {
    const productType = product.productType?.toLowerCase();
    const productSubType = product.productSubType?.toLowerCase();

    if (productType === 'insurance') {
      return productSubType === 'auto'
        ? 'auto insurance'
        : productSubType === 'home'
        ? 'home insurance'
        : `${productSubType} insurance`;
    }
    return productType === 'membership' ? 'membership' : productType;
  });
  const flow = productTypes.join(', ');
  return flow;
};

export const getPaymentPBLTaggingInsurancePolicies = (payByLinkData: IPayByLinkData | undefined) => {
  const products = payByLinkData?.products || [];
  const insurancePolicies = products
    .filter((product: any) => product.productType?.toLowerCase() === 'insurance')
    .map((product: any) => product.productPrefix);
  return insurancePolicies;
};

export const getPaymentTypeTagging = (paymentType: PaymentType | undefined) => {
  const paymentTypesTagging: Partial<Record<PaymentType, PaymentTypeTagging>> = {
    [PaymentType.CreditOrDebit]: PaymentTypeTagging.CreditCard,
    [PaymentType.DebitOnly]: PaymentTypeTagging.DebitCard,
    [PaymentType.Echeck]: PaymentTypeTagging.Echeck,
    [PaymentType.Apple]: PaymentTypeTagging.Apple,
    [PaymentType.Google]: PaymentTypeTagging.Google,
  };

  if (!paymentType || !(paymentType in paymentTypesTagging)) {
    console.error(`Invalid tagging payment type: ${paymentType}`);
    return undefined;
  }

  return paymentTypesTagging[paymentType];
};

export const getPreselectedPaymentOptionId = (
  newPaymentOptions?: { id: string | number }[]
): string | undefined => {
  if (!newPaymentOptions || newPaymentOptions.length === 0) return undefined;
  if (newPaymentOptions.some((opt) => opt.id === PaymentType.Apple)) return PaymentType.Apple;
  if (newPaymentOptions.some((opt) => opt.id === PaymentType.Google)) return PaymentType.Google;
  return undefined;
};
